/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaMatchDaySmall = {
    properties: {
        matchDay: {
            type: 'number',
            isRequired: true,
        },
        points: {
            type: 'number',
            isRequired: true,
        },
        autoPoints: {
            type: 'boolean',
            isRequired: true,
        },
        fromDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        toDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        lineupCompleted: {
            type: 'boolean',
            isRequired: true,
        },
        boosterPoints: {
            type: 'number',
            isRequired: true,
        },
        boosterCompleted: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
